export default "__VITE_PUBLIC_ASSET__ec08c230__"